import { empty } from "../utils/Validation";

export function getSessionKey(){
  return "onlineddash";
}

/**
 * Creates a new session of a user, this session is not an HTTP based session object, rather a simple token in sessionStorage.
 * This should not be used to put values in sessionStorage as it puts value against a specific key.
 *
 * Putting value other than the user login token will lead in session logout.
 *
 * @export
 * @param {*} token
 */
export function createSession(token) {
  sessionStorage.onlineddash = JSON.stringify(token);
}

/**
 * Get the session (token) from the sessionStorage. If there is no session, returns null/undefined.
 * 
 * If the decoded token is needed, refer to @getDecodedToken() method
 * @export
 * @returns token
 */
export function getSession() {

  var session = null;
  session = sessionStorage.onlineddash;
  if(!empty(session)){ 
    return JSON.parse(session);
  }else{
    return null;
  }
}

/**
 * Delete the session of a signed user from the sessionStorage
 *
 * @export
 */
export function clearSession() {
  sessionStorage.removeItem("onlineddash");
  sessionStorage.clear();
}

